import { MenuItem } from 'types';
import {
  Home,
  Search,
  Listing,
  AddOns,
  CustomerInformationForm,
  PaymentOption,
  ConfirmedBooking,
  Location,
} from 'pages';

export const menuItems: MenuItem[] = [
  {
    name: 'Home',
    path: '/',
    // page: Home,
    navbar: 'default',
    title: 'Home Page',
    queryParams: { param: 'value' },
  },
  {
    name: 'Search',
    path: '/search/spot-rental',
    // page: Search,
    navbar: 'default',
    title: 'Search Daily & weekly',
  },
  {
    name: 'Location',
    path: '/location/:locationTypeParams',
    // page: Location,
    navbar: 'custom',
    title: 'Your Location',
  },
  {
    name: 'Search',
    path: '/search/spacial-monthly',
    // page: Search,
    navbar: 'default',
    title: 'Seach Monthly',
  },
  {
    name: 'Listing',
    path: '/listing',
    // page: Listing,
    navbar: undefined,
    title: 'Your Car',
  },
  {
    name: 'Vehicle Addons',
    path: '/vehicle-addons',
    // page: AddOns,
    navbar: 'custom',
    title: 'Add-ons & Extras',
  },
  {
    name: 'Customer Information',
    path: '/customer-information',
    page: CustomerInformationForm,
    navbar: 'custom',
    title: 'Information',
  },
  {
    name: 'Payment Option',
    path: '/payment-option',
    // page: PaymentOption,
    navbar: 'custom',
    title: 'Payment Option',
  },
  {
    name: 'Confirmed Booking',
    path: '/confirmed-booking',
    // page: ConfirmedBooking,
    navbar: 'default',
    title: 'Booking Confirmed',
  },
  {
    name: 'Terms & Conditions',
    path: '/terms-condition',
    // page: ConfirmedBooking,
    navbar: undefined,
    title: 'Terms And Conditions',
  },
];
